var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c(
        "div",
        [
          _vm._m(0),
          _vm._v(" "),
          _c("booking-history-modal", { attrs: { booking: _vm.booking } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "item-detail item-detail-simple" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "#modal-change-log",
              "data-toggle": "modal",
              "data-target": "#modal-change-log",
            },
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-8" }, [
                _c("h3", [_vm._v("Change Log")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-4" }, [
                _c("div", { staticClass: "actions pull-right" }, [
                  _c("span", { staticClass: "btn btn-info" }, [
                    _c("i", { staticClass: "fa fa-eye" }),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }